import { ceil, floor } from 'lodash';

export type PaymentCurrency = {
  currencyCode: string;
  name: string;
  symbol: string;
  minimumPaymentAmount: number;
  hasDecimal: boolean;
};

// JS math leaves floating point errors.
// 10 decimals is pretty safe to truncate.
const fixFloat = (n: number) => floor(n, 10);

const toNoDecimal = (amount: number) => ceil(fixFloat(amount), 0);

const toDecimal = (amount: number) => ceil(fixFloat(amount), 2).toFixed(2);

export const shortDisplayCurrency = (amount: number, currency: PaymentCurrency | null | undefined) => {
  return currency
    ? `${currency.symbol}${currency.hasDecimal ? toDecimal(amount) : toNoDecimal(amount)}`
    : `${toNoDecimal(amount)}`;
};

export const longDisplayCurrency = (amount: number, currency: PaymentCurrency | null | undefined) => {
  return currency
    ? `${currency.symbol}${currency.hasDecimal ? toDecimal(amount) : toNoDecimal(amount)} ${currency.currencyCode}`
    : `${toNoDecimal(amount)}`;
};

export const fullDisplayCurrency = (amount: number, currency: PaymentCurrency | null | undefined) => {
  return currency
    ? `${currency.symbol}${currency.hasDecimal ? toDecimal(amount) : toNoDecimal(amount)} ${currency.currencyCode} (${
        currency.name
      })`
    : `${toNoDecimal(amount)}`;
};
